export enum InsuranceTypeEnum {
  CANCELLATION = 'CANCELLATION',
  REPATRIATION = 'REPATRIATION'
}

export const insuranceTypeEnumMap: Record<InsuranceTypeEnum, string> = {
  [InsuranceTypeEnum.CANCELLATION]: 'Annulation',
  [InsuranceTypeEnum.REPATRIATION]: 'Rapatriement'
}

// "Contrat, facture, attestations" of the client space: each insurance has its own general provisions
export const insuranceGeneralProvisionsLabelMap: Record<InsuranceTypeEnum, string> = {
  [InsuranceTypeEnum.CANCELLATION]: "Dispositions générales concernant l'assurance annulation",
  [InsuranceTypeEnum.REPATRIATION]:
    "Dispositions générales concernant l'assurance assistance rapatriement"
}
